import { useState, useEffect } from 'react';
import logo from '@/pages/img/exato_logo.jpeg';


export default function Navbar() {
  const bglogo = "#F7F7F7"
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id: string) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className="fixed top-0 left-0 w-full z-50 border-b border-gray-100" style={{ backgroundColor: bglogo }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-32 md:h-36">
        {/* Logo */}
        <a href="/" className="flex items-center gap-2 cursor-pointer">
          <img
            src={logo}
            alt="EXATO Cálculos Trabalhistas"
            className="h-24 md:h-28 object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {[
            { label: 'Sobre', id: 'sobre' },
            { label: 'Diferenciais', id: 'diferenciais' },
            { label: 'Curso', id: 'curso' },
            { label: 'Plataforma', id: 'plataforma' },
            { label: 'Contato', id: 'contato' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-sm font-medium transition-colors cursor-pointer whitespace-nowrap text-gray-600 hover:text-gray-900"
            >
              {item.label}
            </button>
          ))}
        </nav>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <button
            onClick={() => window.open('https://portal.exatocalculos.com.br', '_blank', 'noopener,noreferrer')}
            className="mt-2 px-5 py-2.5 rounded-lg text-sm font-semibold text-white cursor-pointer whitespace-nowrap"
            style={{ background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)' }}
          >
            Acessar Plataforma
          </button>
        </div>

        {/* Hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl text-gray-800`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          {[
            { label: 'Sobre', id: 'sobre' },
            { label: 'Diferenciais', id: 'diferenciais' },
            { label: 'Curso', id: 'curso' },
            { label: 'Plataforma', id: 'plataforma' },
            { label: 'Contato', id: 'contato' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-sm font-medium text-gray-700 hover:text-sky-600 text-left cursor-pointer"
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => window.open('https://portal.exatocalculos.com.br', '_blank', 'noopener,noreferrer')}
            className="mt-2 px-5 py-2.5 rounded-lg text-sm font-semibold text-white cursor-pointer whitespace-nowrap"
            style={{ background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)' }}
          >
            Acessar Plataforma
          </button>
        </div>
      )}
    </header>
  );
}
